import React, { useState } from "react";
import { t } from "i18next";
import { useAlert } from "../../../../../../contexts/alert-context";
import {
  getAdrressByEntityId,
  getCountryConfigById,
} from "../../../../../../services/address-service";
import {
  sendDealerEmail,
  updateIdsDealersInvited,
} from "../../../../scrap-admin-service";

interface ModalProps {
  onClose: () => void;
  multIDS: any[];
  id: string | any[];
  materialID?: string;
  sendedIdsHandler?: (arg: string[]) => void;
  formData?: any;
}

const ScrapDealersSendMailModal: React.FC<ModalProps> = ({
  onClose,
  multIDS,
  id,
  materialID,
  sendedIdsHandler,
  formData,
}) => {
  const { setAlert } = useAlert();
  const [disableLoadingButton, setDisableLoadingButton] =
    useState<boolean>(false);

  const handlerSend = async () => {
    setDisableLoadingButton(true);
    try {
      const addresses = await Promise.all(
        multIDS.map((item) => getAdrressByEntityId(item.id))
      );

      const countryConfigs = await Promise.all(
        addresses.map((data) => getCountryConfigById(data.country))
      );

      setAlert({
        text: t("label-invite-sended"),
        type: "success",
      });

      for (let index = 0; index < multIDS.length; index++) {
        const item = multIDS[index];
        const countryConfig = countryConfigs[index];
        const language = countryConfig.locale.startsWith("pt") ? "pt" : "en";

        await sendDealerEmail(id as string, item.id, language);
      }

      updateIdsDealersInvited(multIDS, id as string);
    } catch (error) {
      setAlert({
        text: t("label-email-sent-error"),
        type: "error",
      });

      console.error("Error sending invites:", error);
    }
    onClose();
    setDisableLoadingButton(false);
  };

  return (
    <div className="modal-content" style={{ padding: "2rem" }}>
      <div className="flex-column margin-topbottom-1">
        <label>{t("label-send-mail-modal")}</label>
        {multIDS.map((obj) => (
          <input
            key={obj.id}
            style={{ marginTop: "1rem" }}
            type="text"
            disabled
            name="dealerName"
            value={obj.name}
          />
        ))}
      </div>
      <div className="flex-row buttons-section">
        <button
          className="neutral-white"
          onClick={onClose}
          type="button"
          style={{ margin: "1rem" }}
        >
          {t("label-back")}
        </button>
        <button
          style={{ margin: "1rem" }}
          className="blue"
          type="submit"
          onClick={handlerSend}
          disabled={disableLoadingButton}
        >
          {t("label-send")}
        </button>
      </div>
    </div>
  );
};

export default ScrapDealersSendMailModal;
